<template>
  <div v-frag>
    <div v-frag v-if="$vuetify.breakpoint.name == 'xs'">
      <v-card class="rounded-xl" :color="colorCard" elevation="0">
        <v-card-title
          class="white--text pt-1 pb-2 pl-5 text-xs-h6 text-sm-h6 text-md-h6 text-lg-h6 text-xl-h6 font-weight-light"
          >{{ title }}</v-card-title
        > 
        <v-card class="rounded-xl" color="secondaryApp" elevation="0">
          <v-container fluid>
            <slot></slot>
          </v-container>
        </v-card>
      </v-card>
    </div>
    <div v-frag v-else>
      <v-card
        class="rounded-tl-xl rounded-tr-xl"
        :color="colorCard"
        elevation="0"
        width="50%"
        height="70"
        style="position:absolute"
      >
        <v-card-title
          class="white--text pt-1 pb-2 pl-5 text-xs-h6 text-sm-h6 text-md-h6 text-lg-h6 text-xl-h6 font-weight-light"
          >{{ title }}</v-card-title
        >
      </v-card>
      <v-card class="rounded-xl mt-9" color="secondaryApp" elevation="0">
        <v-container fluid>
          <slot></slot>
        </v-container>
      </v-card>
    </div>
  </div>
</template>

<script>
// import Logo from "../assets/logo.png"
export default {
  name: "CardIeaApp",
  props: ["colorCard", "title"],
  mounted() {},
  computed: {
    createBackgroundString() {
      return `linear-gradient(90deg, rgba(167,186,56,1) 50%, rgba(255,255,255,1) 50%)`;
    }
  },
  components: {},
  data: () => ({})
};
</script>
